/**
 * 截图工具
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/2/2      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import {Button,Modal} from 'antd';
import Cropper from 'react-cropper';
import "cropperjs/dist/cropper.css";
import PropTypes from "prop-types";
class ImgCut extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      visible:false
    }
    this.ImageWidth = 0;
    this.ImageHeight = 0;
  }

  /**
   * 修改弹窗是否可见
   */
  changeVisible(visible){
    if(visible&&!this.ImageWidth){
      $.ajax({
        url: `${this.props.src}?x-oss-process=image/info`,
        type:'get',
        dataType: "json",
        contentType: 'application/json',
        data:JSON.stringify({}),
        success:(res)=>{
          this.ImageWidth = Number(res.ImageWidth&&res.ImageWidth.value||0);
          this.ImageHeight = Number(res.ImageHeight&&res.ImageHeight.value||0);
          this.setState({
            visible:visible
          })
        }
      });
    }else{
      this.setState({
        visible:visible
      })
    }


  }

  cropImage() {
    // console.log(this.cropper.getCroppedCanvas().toDataURL(),"this.cropper.getCroppedCanvas().toDataURL()");

    // console.log(this.cropper.cropBoxData,"this.cropper.cropBoxData");
    // console.log(this.cropper.getCropBoxData(),"this.cropper.getCropBoxData()");
    let data = this.cropper.getCropBoxData()
    let ratio = this.getRatio(data);
    /*var x1 = parseInt(Number(data.left)/ratio);
    var x2 = parseInt(Number(data.width)/ratio+Number(data.left)/ratio);
    var y1 = parseInt(Number(data.top)/ratio);
    var y2 = parseInt(Number(data.top)/ratio+Number(data.height)/ratio);
    console.log(`${x1},${x2},${y1},${y2}`);*/
    // console.log(this.cropper,"this.cropper");
    this.setState({
      visible:false
    },()=>{
      this.props.callBack({
        x:parseInt(Number(data.left)/ratio),
        y:parseInt(Number(data.top)/ratio),
        w:parseInt(Number(data.width)/ratio),
        h:parseInt(Number(data.height)/ratio),
        isCutImg:true
      })
    })

  }

  /**
   * 获取比例
   * @param data
   * @param size
   * @return {number}
   */
  getRatio(data,size=400){
    let ratio = null;
    /*if(this.ImageWidth>size||this.ImageHeight>400){
      if(this.ImageWidth>this.ImageHeight){
        ratio = 400/this.ImageWidth;
      }else{
        ratio = 400/this.ImageHeight;
      }
    }else{
      if(this.ImageWidth>this.ImageHeight){
        ratio = 400/this.ImageWidth;
      }else{
        ratio = 400/this.ImageHeight;
      }
    }*/
    if(this.ImageWidth>this.ImageHeight){
      ratio = size/this.ImageWidth;
    }else{
      ratio = size/this.ImageHeight;
    }
    return ratio;
  }

  render(){
    let size = 400;
    let data = this.props.data;
    let style = {};
    if(this.state.visible){
      let ratio = this.getRatio(data);
      style = Number(this.ImageWidth)>Number(this.ImageHeight)?{margin:'0 auto',width:size,height:this.ImageHeight*ratio}:{margin:'0 auto',width:this.ImageWidth*ratio,height:size};
    }
    return (
      <span className="align-self-center">
                <span onClick={this.changeVisible.bind(this)}>{this.props.children}</span>
        {
          this.state.visible?
            <Modal width={size+48}
                   closable={false}
                   open={this.state.visible}
                   title={false}
                   footer={null}>
              <Cropper
                src={this.props.src}
                data={{x:Number(data.x),y:Number(data.y),width:data.w,height:data.h}}
                onInitialized={(instance) => {
                  this.cropper = instance;
                }}
                minContainerWidth={1}
                minContainerHeight={1}
                zoomable={false}
                // autoCropArea={1}
                style={style}
                guides={false}
              />
              <div className="mt_20 text-center">
                <Button type="primary" className="mr_10" onClick={this.cropImage.bind(this)}>{__getServerLanguage('QueDing')}</Button>
                <Button onClick={this.changeVisible.bind(this,false)}>{__getServerLanguage('QuXiao')}</Button>
              </div>
            </Modal>
            :
            null
        }

            </span>
    )
  }
}

ImgCut.defaultProps = {
  data:{}
}

ImgCut.propTypes = {

}
export default ImgCut;
